module.exports = {
	"components.CameraCardList.alertNoData": "No data",
	"components.CameraCardList.buttonCancel": "Cancel",
	"components.CameraCardList.buttonEdit": "Edit",
	"components.CameraCardList.buttonReplay": "Replay",
	"components.CameraCardList.buttonSave": "Save",
	"components.CameraCardList.labeStoreName": "Store",
	"components.CameraCardList.labelPlaceName": "Place",
	"components.CameraCardList.labelStatus": "Status",
	"components.ChangePasswordPanel.alertChangePasswordSucess": "Change Password Success",
	"components.ChangePasswordPanel.alertTokenError": "Token Error",
	"components.ChangePasswordPanel.buttonRelogin": "Relogin",
	"components.ChangePasswordPanel.buttonSave": "Save",
	"components.ChangePasswordPanel.labelPassword": "Password",
	"components.ChangePasswordPanel.labelPasswordAgain": "Please enter password again",
	"components.ChangePasswordPanel.titleChangePassword": "Reset Password",
	"components.ChangePasswordPanel.warningPasswordsAreDifferent": "Two password are not matched",
	"components.DatetimePeriod.labelFrom": "From",
	"components.DatetimePeriod.labelTo": "To",
	"components.GroupListPanel.buttonCreate": "Create",
	"components.Header.backToTheTop": "Back to the top",
	"components.LoginForm.alertLoginFail": "Login failed",
	"components.LoginForm.alertSentEmail": "The resset email will send to {email}, please check your mailbox",
	"components.LoginForm.buttonConfirm": "Confirm",
	"components.LoginForm.buttonLogin": "Login",
	"components.LoginForm.buttonSubmit": "Submit",
	"components.LoginForm.labelEmailOrUsername": "Email or Username",
	"components.LoginForm.labelForgotPassword": "Forgot password ?",
	"components.LoginForm.labelRememberMe": "Remember me",
	"components.LoginForm.placeholderPassword": "password",
	"components.LoginForm.placeholderUsername": "username",
	"components.LoginForm.title": "Forgot Password",
	"routes.AccountManagement.components.alertasswordDoesntMatchPleaseEnterAgaian": "Two password doesn't match, please enter again",
	"routes.AccountManagement.components.buttonCreate": "Create",
	"routes.AccountManagement.components.buttonSave": "Save",
	"routes.AccountManagement.components.copied": "Copied",
	"routes.AccountManagement.components.developerSettings": "Developer Settings",
	"routes.AccountManagement.components.generateApiToken": "Generate new api token",
	"routes.AccountManagement.components.generateApiTokenDescription": "Warning! Generate new token will revoke old one",
	"routes.AccountManagement.components.generateApiTokenSuccessMessage": "Make sure to copy your new personal access token now. You won’t be able to see it again!",
	"routes.AccountManagement.components.labelAuhtorizedDevices": "Authroized Devices",
	"routes.AccountManagement.components.labelAuhtorizedFeatures": "Authorized Features",
	"routes.AccountManagement.components.labelEmail": "Email",
	"routes.AccountManagement.components.labelPassword": "Password",
	"routes.AccountManagement.components.labelPleaseEnterPasswordAgain": "Please enter password again",
	"routes.AccountManagement.components.labelUsername": "username",
	"routes.AccountManagement.components.linkNotification": "Notification Setting",
	"routes.AccountManagement.components.linkSetting": "Setting",
	"routes.AccountManagement.components.linkSubuser": "Subuser Setting",
	"routes.AccountManagement.components.posDeviceTokens": "POS device tokens",
	"routes.AccountManagement.components.roleAdminNotSupportSubuserFeatureMessage": "Role admin doesn't support subuser feature, please login with other account",
	"routes.AccountManagement.components.tdDelete": "Delete",
	"routes.AccountManagement.components.tdEdit": "Edit",
	"routes.AccountManagement.components.thAuthDevices": "Authroized Devices",
	"routes.AccountManagement.components.thEmail": "Email",
	"routes.AccountManagement.components.thUsername": "Username",
	"routes.AccountManagement.components.title": "User Management",
	"routes.AccountManagement.components.titleCreateSubuser": "Create subuser",
	"routes.AccountManagement.components.titleEditSubuser": "Edit subuser",
	"components.Header.logout": "Logout",
	"components.Header.back": "Back",
	"routes.PatientMonitoring.components.areaMonitoring": "Area Monitoring",
	"routes.PatientMonitoring.components.realtimeMonitoring": "Realtime Status",
	"routes.PatientMonitoring.components.HistorySearching": "History Query",
	"routes.PatientMonitoring.components.fullScreen": "Full Screen",
	"routes.PatientMonitoring.components.CloseFullScreen": "Close Full Screen",
	"routes.PatientMonitoring.components.keyWard": "Ward：",
	"routes.PatientMonitoring.components.keyBed": "Bed：",
	"routes.PatientMonitoring.components.keyPatientId": "Medical Record No.：",
	"routes.PatientMonitoring.components.keyPatientName": "Name：",
	"routes.PatientMonitoring.components.keyMonitorDate": "Date of Admission：",
	"routes.PatientMonitoring.components.keyDateOfBirth": "Date of Birth：",
	"routes.PatientMonitoring.components.labelName": "Period",
	"routes.PatientMonitoring.components.labelTo": "to",
	"routes.PatientMonitoring.components.bedcard_state_hr_warm": "HR WARM",
	"routes.PatientMonitoring.components.bedcard_state_rr_warm": "RR WARM",
	"routes.PatientMonitoring.components.bedcard_state_temp_warm": "Temp. WARM",
	"routes.PatientMonitoring.components.bedcard_state_warm": "WARM",
	"routes.PatientMonitoring.components.bedcard_state_offbed": "Off Bed",
	"routes.PatientMonitoring.components.bedcard_state_onbed": "On Bed",
	"routes.PatientMonitoring.components.bedcard_state_getup": "WAKE",
	"routes.PatientMonitoring.components.bedcard_state_offline": "OFF LINE",
	"routes.PatientMonitoring.components.bedcard_state_move": "MOVE",
	"routes.PatientMonitoring.components.buttonSearch": "Search",
	"routes.PatientMonitoring.components.placeholderPleaseSelect": "Quick Search",
	"routes.PatientMonitoring.components.threeDays": "Three Days",
	"routes.PatientMonitoring.components.oneWeek": "One Week",
	"routes.PatientMonitoring.components.oneMonth": "One Month",
	"routes.PatientMonitoring.components.keyHeartRate": "HR",
	"routes.PatientMonitoring.components.keyRespiratoryRate": "RR",
	"routes.PatientMonitoring.components.keyTemperature": "Temp",
	"routes.PatientMonitoring.components.keyMovement": "Move",
	"routes.PatientMonitoring.components.onBed": "on bed",
	"routes.PatientMonitoring.components.notOnBed": "Not Data",
	"routes.PatientMonitoring.components.avg": "avg",
	"routes.PatientMonitoring.components.rrBpm": "bpm",
	"routes.PatientMonitoring.components.heartBpm": "bpm",
	"routes.PatientMonitoring.components.QuickSearchTitleHeartRate": "Heart Rate",
	"routes.PatientMonitoring.components.QuickSearchTitleRespiratoryRate": "Respiratory Rate",
	"routes.PatientMonitoring.components.QuickSearchTitleTemperature": "Body Temperature",
	"routes.PatientMonitoring.components.QuickSearchTitleMovement": "Movement",
	"routes.PatientMonitoring.components.QuickSearchTitleToday": "Today",
	"routes.PatientMonitoring.components.QuickSearchTitleThreeDay": "3 Days",
	"routes.PatientMonitoring.components.QuickSearchTitleSevenDay": "7 Days",
	"routes.PatientMonitoring.components.HistoryTitleHeartRate": "Heart Rate",
	"routes.PatientMonitoring.components.HistoryTitleRespiratoryRate": "Respiratory Rate",
	"routes.PatientMonitoring.components.HistoryTitleTemperature": "Body Temperature",
	"routes.PatientMonitoring.components.HistoryTitleMovement": "Movement",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCreate": "Create",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonEdit": "Edit",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCancel": "Cance",
	"routes.SystemSetting.components.systemsetting_form_alarm_setting": "Add New Alarm",
	"routes.SystemSetting.components.systemsetting_form_alarm_area": "Area",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyAll": "ALL",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyHR": "HR",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyRR": "RR",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyTemp": "Temp.",
	"routes.SystemSetting.components.systemsetting_form_alarm_notify": "Notify",
	"routes.SystemSetting.components.systemsetting_form_alarm_duration": "Duration",
	"routes.SystemSetting.components.systemsetting_form_alarm_notifyThreshold": "Threshold"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 3469
// module chunks = 6